import { FC } from 'react';
import { FlexboxGrid } from 'rsuite';

const FooterContent: FC = () => {
  return (
    <FlexboxGrid justify="space-between" align="middle"
      style={{
        padding: '20px 56px',
        backgroundColor: '#F9F9FE'
      }}
    >
      <FlexboxGrid.Item>
        <img src="/media/iso.svg" alt="Logo Footer AMSA" />
      </FlexboxGrid.Item>

      <FlexboxGrid.Item>
        <span className="label">
          © 2022 AMSA - TICA - DDSD
        </span>
      </FlexboxGrid.Item>

      <FlexboxGrid.Item></FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default FooterContent;